(function () {
  'use strict';

  var CARD_SELECTOR = 'main[data-template^="product"] product-recommendations product-card';
  var INTERACTIVE_SELECTOR = 'a,button,input,label,select,textarea,summary,[role="button"]';

  function getProductHref(card) {
    var link = card.querySelector('a[ref="productCardLink"], .dm-recommendation-card__link');
    return link && link.href ? link.href : '';
  }

  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element) || event.defaultPrevented) return;

    var card = event.target.closest(CARD_SELECTOR);
    if (!card) return;

    var interactive = event.target.closest(INTERACTIVE_SELECTOR);
    // Horizon renders the visible product title inside a display:contents
    // anchor. Keep that title in the fallback path because some browsers do
    // not hit-test the zero-size anchor reliably.
    if (interactive && !interactive.matches('a[ref="productTitleLink"]')) return;

    var href = getProductHref(card);
    if (!href) return;

    event.preventDefault();
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
      window.open(href, '_blank', 'noopener');
    } else {
      window.location.assign(href);
    }
  }, true);
})();
